import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const REDIRECT_DELAY_MS = 2000;

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      padding: 24,
      background: '#fff',
    },
  })
);

interface NoAccessNoticeProps {
  redirectTo: string;
}

export default function NoAccessNotice({ redirectTo }: NoAccessNoticeProps) {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      history.replace(redirectTo);
    }, REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [history, redirectTo]);

  return (
    <Box className={classes.root}>
      <Typography variant='h5' gutterBottom>
        You don&apos;t have access
      </Typography>
      <Typography variant='body1' color='textSecondary'>
        Taking you back to your workspace.
      </Typography>
    </Box>
  );
}
